<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      :type="type"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        perfect
        size="mini"
        align="right"
        slot="pager"
        :layouts="['Total', 'Sizes', 'PrevPage', 'JumpNumber', 'NextPage']"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
  </div>
</template>

<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
export default {
  mixins: [BaseTable],
  components: {
    PageHeader,
    PageMain,
  },
  props: {
    type: String,
  },
  data() {
    return {
      usePage: true,
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .sampleInfoAuditListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    choiceData() {
      return this.$refs.main.choiceData()
    },
  },
}
</script>
